import { useBilling } from './useBilling';
import { HistoryTable } from './HistoryTable';

export const Billing: React.FC = () => {
    const { billingList } = useBilling();
    return <HistoryTable billingList={billingList} />;
};
